module.exports = __webpack_public_path__ + "img/hire3x-mini-logo.6fe62891.svg";